import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900 mb-3">{contactData.title}</h2>
        <p className="text-sm text-foreground-600 mb-8 md:mb-10 leading-relaxed">{contactData.description}</p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
            <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-mail-line text-primary-600 text-lg"></i>
            </div>
            <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
            <div className="text-sm font-medium text-foreground-900 break-all">{contactData.email}</div>
          </div>
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
            <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-wechat-line text-accent-600 text-lg"></i>
            </div>
            <div className="text-xs text-foreground-500 mb-1">微信</div>
            <div className="text-sm font-medium text-foreground-900">{contactData.wechat}</div>
          </div>
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
            <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-qq-line text-secondary-600 text-lg"></i>
            </div>
            <div className="text-xs text-foreground-500 mb-1">QQ</div>
            <div className="text-sm font-medium text-foreground-900">{contactData.qq}</div>
          </div>
        </div>
      </div>
    </section>
  );
}